// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aaae582b","455":"29151637","946":"6c497f3d"}[chunkId] + ".chunk.js";
};